export default __webpack_public_path__ + "static/media/infos_professionnelles.e27525ed.svg";